import React, { Component } from "react";

import { DKLabel, DKButton } from "deskera-ui-library";
import CampaignManager from "./CampaignManager";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import DirectLinkSection from "../common/DirectLinkSection";
import CampaignPageHeader from "./CampaignPageHeader";

class CampaignSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    RouteManager.setPresenter(this);
    if (
      !CampaignManager.isPageDataAvailable() &&
      this.props.match.params.id
    ) {
      CampaignManager.fetchPageDataById(this.props.match.params.id, () => {
        this.setState({});
      });
    }
  }
  render() {
    return (
      <div className="column parent-width  ">
        <CampaignPageHeader title={"Publish Template"} stepperIndex={3} />
        <div
          className="column p-xxl bg-white border-radius-s parent-width border-box mt-xl align-self-center shadow-s align-items-center"
          style={{ maxWidth: 800, marginBottom: 100 }}
        >
          <DKLabel text={CampaignManager.checkCampaignSent() ? CampaignManager.campaignSent : CampaignManager.campaignActivate} className="fw-m fs-xl" />
          <DKLabel
            text={CampaignManager.checkCampaignSent() ? CampaignManager.yourCampaignSent : CampaignManager.yourCampaignStarted}
            className="text-gray fs-m mt-s text-align-center"
          />
          <div className="mt-l" style={{ fontSize: 70 }}>
            🎉
          </div>
          <DKLabel text="Congratulations!" className="fw-m mt-l fs-l" />
          <DKLabel
            text={CampaignManager.checkCampaignSent() ? CampaignManager.yourCampaignSent : CampaignManager.yourCampaignActivatedAndStarted}
            className="mt-s"
          />
          <DKLabel
            text="You can visit to template homepage / list page to see how it is performing."
            className="mt-s text-gray"
          />
          <DirectLinkSection
            className="mt-xl"
            url={CampaignManager.getDirectLink()}
          />

          <DKButton
            title="Goto Campaign list"
            className="bg-app text-white mt-xl"
            onClick={() => {
              RouteManager.navigateToPage(PAGE_ROUTES.CAMPAIGN);
            }}
          />
        </div>
      </div>
    );
  }
}

export default CampaignSuccess;
